module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/cup/5-d75580de0f5948d42ab157f4fe0f0cd6.jpg";